var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6079 6.47508C14.5495 6.46675 14.4912 6.46675 14.4329 6.47508C13.1412 6.43342 12.1162 5.37508 12.1162 4.07508C12.1162 2.75008 13.1912 1.66675 14.5245 1.66675C15.8495 1.66675 16.9329 2.74175 16.9329 4.07508C16.9245 5.37508 15.8995 6.43342 14.6079 6.47508Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3247 12.2501C16.3913 12.8751 15.083 13.1084 13.8747 12.9501C14.1913 12.2667 14.358 11.5084 14.3663 10.7084C14.3663 9.87509 14.183 9.08343 13.833 8.39176C15.0663 8.22509 16.3747 8.45842 17.3163 9.08342C18.633 9.95008 18.633 11.3751 17.3247 12.2501Z",
    fill: "#CCCFD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36699 6.47508C5.42532 6.46675 5.48366 6.46675 5.54199 6.47508C6.83366 6.43342 7.85866 5.37508 7.85866 4.07508C7.85866 2.75008 6.78366 1.66675 5.45033 1.66675C4.12532 1.66675 3.04199 2.74175 3.04199 4.07508C3.05033 5.37508 4.07532 6.43342 5.36699 6.47508Z",
    fill: "#CCCFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45794 10.7083C5.45794 11.5167 5.63294 12.2833 5.94961 12.975C4.77461 13.1 3.54961 12.85 2.64961 12.2583C1.33294 11.3833 1.33294 9.95833 2.64961 9.08333C3.54128 8.48333 4.79961 8.24167 5.98294 8.37501C5.64128 9.07501 5.45794 9.86668 5.45794 10.7083Z",
    fill: "#CCCFD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 13.225C10.0333 13.2167 9.95833 13.2167 9.88333 13.225C8.35 13.175 7.125 11.9167 7.125 10.3667C7.125 8.78334 8.4 7.5 9.99167 7.5C11.575 7.5 12.8583 8.78334 12.8583 10.3667C12.8583 11.9167 11.6417 13.175 10.1 13.225Z",
    fill: "#838B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39199 14.95C6.13366 15.7916 6.13366 17.1749 7.39199 18.0083C8.82533 18.9666 11.1753 18.9666 12.6087 18.0083C13.867 17.1666 13.867 15.7833 12.6087 14.95C11.1837 13.9916 8.83366 13.9916 7.39199 14.95Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.caa513a11d02671e557f60811214fcc4.svg";
export { ForwardRef as ReactComponent };